/** Keep fixed dropdowns / sheets inside the viewport (phones, narrow headers). */
export const VIEWPORT_MARGIN = 12;
export const MOBILE_SHEET_MAX_WIDTH = 640;

export function isMobileSheetViewport(breakpoint = MOBILE_SHEET_MAX_WIDTH) {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < breakpoint;
}

/**
 * @param {DOMRect} rect — anchor button getBoundingClientRect()
 * @param {object} options
 * @returns {{ top: number, left: number, width: number, maxHeight: number }}
 */
export function positionPanelBelow(rect, options = {}) {
  const {
    preferredWidth = 280,
    minWidth = 0,
    gap = 6,
    align = 'start',
    margin = VIEWPORT_MARGIN,
  } = options;

  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const maxWidth = vw - margin * 2;

  let width = Math.min(preferredWidth, maxWidth);
  if (minWidth > 0) {
    width = Math.min(Math.max(width, Math.min(minWidth, maxWidth)), maxWidth);
  }

  let left;
  if (align === 'end') {
    left = rect.right - width;
  } else if (align === 'center') {
    left = rect.left + (rect.width - width) / 2;
  } else {
    left = rect.left;
  }
  left = Math.min(Math.max(margin, left), vw - width - margin);

  let top = rect.bottom + gap;
  const maxHeight = Math.min(24 * 16, vh * 0.72);
  if (top + 120 > vh - margin) {
    const above = rect.top - gap - maxHeight;
    if (above >= margin) {
      top = above;
    }
  }

  return { top, left, width, maxHeight };
}
